import { render } from "./VerticalCarousel.vue?vue&type=template&id=5b56bca2&scoped=true"
import script from "./VerticalCarousel.vue?vue&type=script&lang=js"
export * from "./VerticalCarousel.vue?vue&type=script&lang=js"

import "./VerticalCarousel.vue?vue&type=style&index=0&id=5b56bca2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b56bca2"]])

export default __exports__